// extracted by mini-css-extract-plugin
export default {"hed":"hed__MDUwY","card":"card__MjEwO","imageContainer":"imageContainer__ODcyN","body":"body__ZDY0Z","header":"header__YWQxO"};